import DefaultMarketWatch from "src/components/feature/MyProfile";

const MyProfile = () => {
  return <DefaultMarketWatch />;
};

export default MyProfile;
